/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseChargeBackDto } from '../../models/response-charge-back-dto';

export interface GetChargeBacks$Params {
  amount?: string;
  recordDate?: string;
  rebookingsStatus?: string;
  limit?: number;
  offset?: number;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}

export function getChargeBacks(http: HttpClient, rootUrl: string, params?: GetChargeBacks$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseChargeBackDto>> {
  const rb = new RequestBuilder(rootUrl, getChargeBacks.PATH, 'get');
  if (params) {
    rb.query('amount', params.amount, {});
    rb.query('recordDate', params.recordDate, {});
    rb.query('rebookingsStatus', params.rebookingsStatus, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseChargeBackDto>;
    })
  );
}

getChargeBacks.PATH = '/bookings/chargebacks';
